import React from 'react';
import Reveal from './Reveal';
import pitBarn from '../assets/project-pit-barn.png';
import nestCottage from '../assets/project-nest-cottage.webp';
import grattonFarm from '../assets/project-gratton-farm.webp';
import seatonHouse from '../assets/project-seaton-house.webp';

const projects = [
  { img: pitBarn, name: 'Pit Barn' },
  { img: nestCottage, name: 'Nest Cottage, Noss Mayo' },
  { img: grattonFarm, name: 'Gratton Farm, Loddiswell' },
  { img: seatonHouse, name: 'Seaton House' },
];

const Projects = () => {
  return (
    <section id="projects" className="bg-[#262629] px-5 md:px-10 py-16 md:py-20">
      <div className="max-w-[1400px] mx-auto">
        <Reveal>
          <h2 className="font-display text-yellow text-4xl md:text-5xl mb-10">
            Projects we've estimated
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {projects.map((p, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="group relative block aspect-square rounded-2xl overflow-hidden">
                <img
                  src={p.img}
                  alt={p.name}
                  className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                <p className="absolute bottom-5 left-5 right-5 z-10 font-display text-white text-xl md:text-2xl leading-tight">
                  {p.name}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
